import React from 'react';

const InfoIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 50 50"
      xmlSpace="preserve"
    >
      <path
        className="st0"
        d="M25-0.2c-13.8,0-25,11.2-25,25s11.2,25,25,25s25-11.2,25-25S38.8-0.2,25-0.2z M30.9,38.5
          c-1.3,0.5-2.3,0.9-3.1,1.2c-0.8,0.3-1.6,0.4-2.7,0.4c-1.5,0-2.8-0.4-3.6-1.1c-0.9-0.8-1.3-1.7-1.3-2.9c0-0.5,0-0.9,0.1-1.4
          c0.1-0.5,0.2-1,0.3-1.6l1.6-5.7c0.1-0.5,0.3-1.1,0.4-1.5c0.1-0.5,0.1-0.9,0.1-1.3c0-0.7-0.1-1.2-0.4-1.5c-0.3-0.3-0.9-0.4-1.7-0.4
          c-0.4,0-0.8,0.1-1.3,0.2c-0.4,0.1-0.8,0.3-1.1,0.4l0.4-1.7c1-0.4,2.1-0.8,3-1.1c1-0.3,1.9-0.5,2.7-0.5c1.5,0,2.7,0.4,3.6,1.1
          c0.8,0.7,1.2,1.7,1.2,2.9c0,0.2,0,0.7-0.1,1.3c-0.1,0.6-0.2,1.2-0.3,1.7l-1.6,5.6c-0.1,0.5-0.2,1-0.4,1.5c-0.1,0.6-0.2,1-0.2,1.3
          c0,0.7,0.2,1.3,0.5,1.5c0.3,0.3,0.9,0.4,1.7,0.4c0.4,0,0.8-0.1,1.3-0.2c0.5-0.1,0.8-0.3,1.1-0.4L30.9,38.5z M30.6,15.6
          c-0.7,0.7-1.6,1-2.7,1c-1,0-1.9-0.3-2.7-1c-0.7-0.7-1.1-1.5-1.1-2.5c0-1,0.4-1.8,1.1-2.5c0.7-0.7,1.6-1,2.7-1c1,0,1.9,0.3,2.7,1
          c0.7,0.7,1.1,1.5,1.1,2.5C31.7,14.1,31.3,14.9,30.6,15.6z"
      />
    </svg>
  );
};

export default InfoIcon;
